const TokenPlugin = {
  install (Vue, options) {
    let token = {
      idToken: null,
      getIdTokenFromQuery: function () {
        // let idToken = Vue.tool.getQuery()['token']
        Vue.token.idToken = Vue.tool.getQuery()['token']
        // Vue.set(Vue.token, 'idToken', idToken)
        return Vue.token.idToken
      },
      tokenExpirationTimeLeft: function (token) {
        let timeLeft = 0
        try {
          let decodedToken = Vue.tool.decodeJwtToken(token)
          let now = new Date()
          timeLeft = decodedToken.exp * 1000 - now.getTime()
        } catch (err) {
          Vue.logger.error(err)
        }
        Vue.logger.info('id_token is valid for next {timeLeft} minutes.'.replace('{timeLeft}', '' + Math.round(timeLeft / 60000 + 0.5)))
        return timeLeft
      },
      hasValidToken: function () {
        let hasValidToken = false
        let idToken = Vue.token.getIdTokenFromQuery()
        if (idToken) {
          try {
            if (+Vue.token.tokenExpirationTimeLeft(idToken) > 0) hasValidToken = true
          } catch (err) {
            hasValidToken = false
          }
        }
        return hasValidToken
      }
    }
    Vue.prototype.$token = token
    Vue.token = token
  }
}

export default TokenPlugin



// WEBPACK FOOTER //
// ./src/plugins/token.js